import { useMemo } from "react";
import { useModalContext } from "common/contexts";
import useOwnerAssignee from "security-app/components/SecurityEvents/Alerts/hooks/useOwnerTitles";
const useOwnerAction = (securityEvent) => {
  const { setModal, setEntity } = useModalContext();
  const { data: assignee } = useOwnerAssignee(securityEvent.owner);
  const currentOwnerName = useMemo(() => {
    if (assignee == null ? void 0 : assignee.label) return assignee.label;
    if (securityEvent.owner) return "Assigned";
    return void 0;
  }, [assignee, securityEvent.owner]);
  const selectOwner = () => {
    setEntity(securityEvent);
    setModal("SELECT-OWNER");
  };
  const onRemoveOwner = () => {
    setEntity(securityEvent);
    setModal("CONFIRM-OWNER-REMOVE");
  };
  return {
    selectOwner,
    onRemoveOwner,
    currentOwnerName
  };
};
export default useOwnerAction;
